import React, { useState, useEffect } from 'react';
import { Stack, Typography, Card, IconButton, TextField, Button, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBack from '@mui/icons-material/ArrowBack';
import EditIcon from '@mui/icons-material/Edit';
import SendIcon from '@mui/icons-material/Send';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import api from '../Services/Api';
import { useTranslation } from 'react-i18next';

const AudioHistory = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [audioHistory, setAudioHistory] = useState([]);
    const [loading, setLoading] = useState(true);
    const [editingId, setEditingId] = useState(null);
    const [editedText, setEditedText] = useState('');

    useEffect(() => {
        fetchAudioHistory();
    }, []);

    const fetchAudioHistory = async () => {
        try {
            const response = await api.getAudioHistory();
            setAudioHistory(response || []);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching audio history:', error);
            setLoading(false);
        }
    };

    const handleEdit = (id, text) => {
        setEditingId(id);
        setEditedText(text);
    };

    const handleSave = async (id) => {
        try {
            await api.updateAudioText(id, editedText);
            setAudioHistory(audioHistory.map(item => 
                item._id === id ? { ...item, text: editedText } : item
            ));
            setEditingId(null);
        } catch (error) {
            console.error('Error updating audio text:', error);
        }
    };

    const handleResend = async (id, text) => {
        navigate('/app/validate', { state: { text } });
    };

    return (
        <Stack style={{ padding: '1rem', maxWidth: '100%', margin: 'auto' }}>
            <Stack direction="row" spacing={2} style={{ marginBottom: '1rem' }} alignItems="center">
                <IconButton style={{ color: 'white' }} onClick={() => navigate('/app')}>
                    <ArrowBack />
                </IconButton>
                <Typography variant="h5" style={{ color: 'white' }}>{t('audioHistory')}</Typography>
            </Stack>

            {loading ? (
                <Typography style={{ color: 'white' }}>{t('loading')}</Typography>
            ) : audioHistory.length === 0 ? (
                <Typography style={{ color: 'white' }}>{t('noAudioHistory')}</Typography>
            ) : (
                <Grid container spacing={2}>
                    {audioHistory.map((item) => (
                        <Grid item xs={12} key={item._id}>
                            <Card style={{ 
                                backgroundColor: '#FFFFFF10', 
                                borderRadius: '10px', 
                                padding: '1rem',
                                marginBottom: '1rem'
                            }}>
                                <Stack spacing={2}>
                                    <Stack direction="row" justifyContent="space-between" alignItems="center">
                                        <Typography variant="subtitle2" style={{ color: 'white' }}>
                                            {new Date(item.createdAt).toLocaleString()}
                                        </Typography>
                                        <Stack direction="row" spacing={1}>
                                            {editingId === item._id ? (
                                                <>
                                                    <IconButton 
                                                        size="small" 
                                                        onClick={() => handleSave(item._id)}
                                                        style={{ color: 'white' }}
                                                    >
                                                        <CheckIcon />
                                                    </IconButton>
                                                    <IconButton 
                                                        size="small" 
                                                        onClick={() => setEditingId(null)}
                                                        style={{ color: 'white' }}
                                                    >
                                                        <CloseIcon />
                                                    </IconButton>
                                                </>
                                            ) : (
                                                <>
                                                    <IconButton 
                                                        size="small" 
                                                        onClick={() => handleEdit(item._id, item.text)}
                                                        style={{ color: 'white' }}
                                                    >
                                                        <EditIcon />
                                                    </IconButton>
                                                    <IconButton 
                                                        size="small" 
                                                        onClick={() => handleResend(item._id, item.text)}
                                                        style={{ color: 'white' }}
                                                    >
                                                        <SendIcon />
                                                    </IconButton>
                                                </>
                                            )}
                                        </Stack>
                                    </Stack>
                                    {editingId === item._id ? (
                                        <TextField
                                            fullWidth
                                            multiline
                                            value={editedText}
                                            onChange={(e) => setEditedText(e.target.value)}
                                            variant="outlined"
                                            style={{ backgroundColor: '#FFFFFF20', borderRadius: '4px' }}
                                            InputProps={{
                                                style: { color: 'white' }
                                            }}
                                        />
                                    ) : (
                                        <Typography style={{ color: 'white' }}>{item.text}</Typography>
                                    )}
                                </Stack>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            )}
        </Stack>
    );
};

export default AudioHistory;
